import React             from 'react';
import PropTypes         from 'prop-types';

import { TexteToolTip   }   from './TexteToolTip';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                              Version                          ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export class Version extends React.Component {

    /* ------------ */
    /* Constructeur */
    /* ------------ */

    constructor(props){
        super(props);
        this.state = {
            detail : false,
        }
        this.detail = false;
    }

    onMouseMove(e){
        const haut   = e.pageY;
        const droite = window.innerWidth - e.pageX;

        const detail = (haut <= 156) && (droite <= 45);

        if (detail === this.detail) return;

        this.detail = detail;
        this.setState({detail : detail})
    }

    /* ---------------------- */
    /* Affichage du composant */
    /* ---------------------- */

    render()
    {
        /* ------------------ */
        /* Définition des CSS */
        /* ------------------ */

        const styleVersion = this.props.style ? {...this.props.style} : {
            position   : "absolute",
            top        : "0px",
            right      : "0px",
            color      : "#10005A",
            fontFamily : "arial, verdana, times, sans-serif",
            fontSize   : "6pt",
            padding    : "3px"
        }

        const contenu = this.state.detail ? 
            <TexteToolTip 
                texte={"<span class='noir10'>Version <b>" + this.props.version.noVersion + "</b></span><br><span class='noir8'>" + this.props.version.dtVersion + " " + this.props.version.hrVersion + "</span>"} 
            /> :  this.props.version.noVersion;

        /* ------------------- */
        /* Renvoi du composant */
        /* ------------------- */

        return (
                    <div style={styleVersion} 
                        onMouseMove = {(e)=>this.onMouseMove(e)} 
                    >

                    {contenu}

            </div>  
        );
    }
}

/* ------------------------------------ */
/* Définition de la structure des props */
/* ------------------------------------ */

Version.defaultProps = {
    version  : null,
    style    : null
}

Version.propTypes = {
    version : PropTypes.object.isRequired,
    style   : PropTypes.object
}


// WEBPACK FOOTER //
// ./src/components/commun/Version.js